import script from "./ReindexModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReindexModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReindexModal.vue?vue&type=style&index=0&id=786c0cf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786c0cf5"]])

export default __exports__